export function without<T>(values: T[], valuesToExclude: T | T[] | undefined): T[] {
    const toExclude = Array.isArray(valuesToExclude) ? valuesToExclude : [valuesToExclude];
    return values.filter((value) => !toExclude.includes(value));
}
